// Editable-terms task (sales workspace + admin approval screen share both
// helpers — pulled out here rather than duplicated in each page, same
// reasoning utils/formatDate.js already gets shared across this app's
// pages).

import { toEatDateString } from './formatDate.js';

// A DATE column comes back from the API as a full ISO datetime string —
// `<input type="date">` wants just the leading YYYY-MM-DD. Timezone bug fix
// (2026-10-25): this used to be `String(value).slice(0, 10)`, which reads
// the UTC calendar date out of that string. Because mysql2 builds the
// Date at LOCAL (server OS) midnight before it's ever serialized, and this
// server's OS timezone is UTC+3 (confirmed empirically, not the UTC
// docs/DEPLOY.md assumes by default), that UTC calendar date is the wrong
// one — off by a day, same root cause as AllProformasPage.jsx's date
// filter. toEatDateString does the same explicit Africa/Addis_Ababa
// conversion formatDate/formatDateTime already use for display, instead
// of a naive slice, so this stays correct even if the server's OS
// timezone is ever corrected to true UTC (at which point there would be
// no shift to undo, and toEatDateString still gives the right answer
// either way — a slice would not).
export function toDateInputValue(value) {
  return value ? toEatDateString(value) || '' : '';
}

// A plain suggestion for a validity-date box when nothing is saved yet —
// NOT the authoritative default. That is computed in SQL at approval time
// (quotationRepository.approve's COALESCE fallback), which correctly counts
// from the real approval date rather than from whenever this page happens
// to be open. This builds and reads the date entirely with LOCAL (browser)
// getters, never converting through UTC — unlike toDateInputValue above,
// nothing here ever crosses an API boundary, so there is no server-
// timezone mismatch to correct for; converting to a specific IANA zone
// would just substitute one assumption (the admin's OS clock) for another
// (EAT) with no actual correctness gain. Previously used
// `.toISOString().slice(0, 10)`, the same risky idiom fixed above — fixed
// here too even though no MySQL value is involved, since the bug class is
// identical (a day can roll over at the toISOString() UTC conversion).
export function suggestValidUntil(quoteValidityDays) {
  if (!quoteValidityDays) return '';
  const d = new Date();
  d.setDate(d.getDate() + Number(quoteValidityDays));
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}
